























import { defineComponent } from '@vue/composition-api';
import { windowHelper } from '@tencent/ppd-base-libs';
import { MultiJumpContainer, MultiJumpInfo } from '@tencent/wphk-components-multi-jump-container';
import { isTencentCharity } from '@/config/tencent-charity';
import { i18n } from '@/i18n';

export default defineComponent({
  name: 'PageTab',
  components: {
    MultiJumpContainer,
  },
  setup() {
    const jumpInfo: MultiJumpInfo = {
        appid: 'wxff244f6b82a094d2', // 跳转小程序
        username: 'gh_713a18875797', // 跳转小程序
        path: 'pages/activity/index/main?aid=ca_16FPT8ORZSCAV'
    };

    const btnText = isTencentCharity() ? i18n('99公益日') : i18n('慈善');

    return {
      btnText,
      jumpInfo,
      goCharity() {
        windowHelper.redirect('https://apps.wechatpay.com.hk/charity/index.shtml?ADTAG=goodDeedDayPageTab', 0);
      },
    };
  },
});
